// extracted by mini-css-extract-plugin
export var activeLink = "navLinks-module--activeLink--e5776";
export var bottomFade = "navLinks-module--bottom-fade--95e64";
export var fade = "navLinks-module--fade--2da8c";
export var fadeup = "navLinks-module--fadeup--95901";
export var leftFade = "navLinks-module--left-fade--3b767";
export var link = "navLinks-module--link--e9597";
export var links = "navLinks-module--links--43e30";
export var navImage = "navLinks-module--navImage--68ed8";
export var navLinksContainer = "navLinks-module--navLinksContainer--5919c";